import { ProgressBar, ProgressValue, ProgressWrap } from 'olive-react-myoneui';

const ArchiveProgressBar = ({ now }) => {
    let progressColor;
    if (now < 60) {
      progressColor = 'danger';
    } else if (now < 80) {
      progressColor = 'warning';
    } else if (now <= 90) {
      progressColor = 'info';
    } else {
      progressColor = 'success';
    }
  
    return (
        <ProgressWrap>
            <ProgressBar
            variant={progressColor}
            now={now}
            />
            <ProgressValue ProgressPercentage={`${now}%`} />
        </ProgressWrap>
    );
  };
  
  export default ArchiveProgressBar;